import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  PageHeaderMenu,
  PageHeaderMenuItem,
} from '@app/components/pr-page/pr-page-header-menu/pr-page-header-menu.component';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { ProductsTypeEnum } from '@app/forms/subscription/definition/interface';
import { map, switchMap, take } from 'rxjs';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';

interface QueryParams {
  productType: string;
  productId?: string;
}
@Component({
    selector: 'bottom-sheet-overview',
    templateUrl: './bottom-sheet-overview.component.html',
    styleUrls: ['./bottom-sheet-overview.component.scss'],
    standalone: false
})
export class BottomSheetOverviewComponent implements OnInit {
  menus: PageHeaderMenu = {} as PageHeaderMenu;
  userId: any;
  isConsultant: boolean;
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewComponent>,

    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private subscriptionFacade: SubscriptionFacadeService,
    public userDao: UserDao,
    public attributionDao: AttributionDao,
  ) {}

  ngOnInit(): void {
    this.fetchMenus();
    // this.userDao
    //   .getAuthentified()
    //   .pipe(take(1))
    //   .subscribe((user) => {
    //     this.attributionDao.getAttribution().subscribe((attribution) => {
    //       const organizationId = attribution?.organization?.id;

    //       this.isConsultant = !!user.sessionConsultant;

    //       if (!user?.sessionConsultant) {
    //         if(organizationId == 1){
    //           const itemsClient = this.filterClientItemsForEuodia(this.menus.items);
    //           this.menus = { ...this.menus, items: [...itemsClient] };
    //         }
    //         if(organizationId == 251251251){
    //           const itemsClient = this.filterClientItemsForCristalis(this.menus.items);
    //           this.menus = { ...this.menus, items: [...itemsClient] };
    //         }
    //       }
    //       this.userId = user.id;
    //     });
    //   });

    this.userDao
      .getAuthentified()
      .pipe(
        take(1),
        switchMap(user => {
          return this.attributionDao.getAttribution().pipe(
            map(attribution => {
              const organizationId = attribution?.organization?.id;

              this.isConsultant = !!user.sessionConsultant;

              if (!user?.sessionConsultant) {
                if (organizationId == 1) {
                  const itemsClient = this.filterClientItemsForEuodia(
                    this.menus.items,
                  );
                  this.menus = { ...this.menus, items: [...itemsClient] };
                }
                if (organizationId == 251251251) {
                  const itemsClient = this.filterClientItemsForCristalis(
                    this.menus.items,
                  );
                  // this.menus = { ...this.menus, items: [...itemsClient] };
                  this.menus = {};
                }
              }
              this.userId = user.id;
            }),
          );
        }),
      )
      .subscribe();
  }

  private fetchMenus(): void {
    this.menus = this.subscriptionFacade.getMenu();
  }
  private filterClientItemsForEuodia(
    items: PageHeaderMenuItem[],
  ): PageHeaderMenuItem[] {
    const clientItemLabels = [
      ProductsTypeEnum.ASSURANCE_VIE,
      ProductsTypeEnum.CONTRAT_CAPI,
      ProductsTypeEnum.COMPTE_TITRE,
      ProductsTypeEnum.PEA,
      ProductsTypeEnum.PEI,
      ProductsTypeEnum.CROWDFUNDING,
      ProductsTypeEnum.SCPI,
      ProductsTypeEnum.PER,
    ];
    return items?.filter(item =>
      clientItemLabels.includes(item.label as ProductsTypeEnum),
    );
  }

  private filterClientItemsForCristalis(
    items: PageHeaderMenuItem[],
  ): PageHeaderMenuItem[] {
    const clientItemLabels = [ProductsTypeEnum.PRESTATION];
    return items?.filter(item =>
      clientItemLabels.includes(item.label as ProductsTypeEnum),
    );
  }

  openLink(
    event: MouseEvent,
    option: { label: string; productName: string },
  ): void {
    const { productName } = option || {};
    let queryParams: QueryParams = {
      productType: productName,
    };
    if (!this.isConsultant) {
      let productId;
      if (productName == 'ASSURANCE_VIE') productId = '6258550';
      if (productName == 'PER') productId = '6545029';
      if (productId) queryParams.productId = productId;
    }
    this.router.navigate([this.subscriptionFacade.subscriptionRouteInit], {
      relativeTo: this.route,
      queryParams: queryParams,
    });
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
